<template>
  <div>
    <div class="rulebox1">
      <img src="@/assets/hxStatic/rule_title.jpg" />
      <div class="title">首刷礼</div>
      <h4>活动时间</h4>
      <p>2023年7月1日至2023年12月31日（客户核卡日期）</p>
      <h4>活动对象</h4>
      <p>申请华夏银行指定信用卡产品的新户持卡人。</p>
      <h4>活动内容</h4>
      <p>申请华夏银行指定信用卡产品的新户持卡人。主要包含卡产品如下：</p>
      <img src="@/assets/hxStatic/rule1.png" />
      <img src="@/assets/hxStatic/rule2.png" />
      <p>
        畅享首刷礼新客户自成功核卡之日起60天内（含），线上渠道消费满2笔且每笔满199元，可领取价值50元微信立减金礼包（含2张20元和1张10元）。<br />
        怡享首刷礼新客户自成功核卡之日起60天内（含），线上渠道消费满2笔且每笔满99元，可领取价值30元微信立减金礼包（含1张20元和1张10元）。<br />
        尊享首刷礼新客户自核卡之日起60天内（含），线上渠道消费满2笔且每笔满199元，可领取价值30元微信立减金礼包（含1张20元和1张10元）。<br />
        乐享首刷礼新客户自核卡之日起60天内（含），线上渠道消费满2笔且每笔满99元，可领取价值20元微信立减金礼包（含2张10元）。
      </p>
      <h4>礼品领取</h4>
      <p>
        满足达标条件的客户，可于达标次日收到达标短信后30天（含）内，前往“华夏银行信用卡微信公众号-活动·权益-权益平台-精彩活动”或“华彩生活APP-权益平台-精彩活动”进行领取。
      </p>
      <h4>活动细则</h4>
      <p style="text-indent:inherit">
        1、本活动仅限新客户参与：新客户是指申请以上指定信用卡产品前，名下未曾持有华夏银行信用卡的主卡持卡人。<br />
        2、领取有效期为达标日的第二天起至第30天（含），请在活动规定时间内领取，如逾期未领取，则视为放弃该礼品。领取路径：华夏银行信用卡微信公众号-活动·权益-权益平台-精彩活动，或华彩生活APP-权益平台-精彩活动。50元微信立减金礼包领取后，1张20元和1张10元立减金即时生效，其余1张20元将于次月1日生效。30元微信立减金礼包领取后，1张20元立减金即时生效，其余1张10元将于次月1日生效。20元微信立减金礼包领取后，1张10元立减金即时生效，其余1张10元立减金将于次月1日生效。<br />
        3、客户需在立减金生效之日起30天（含）内将微信立减金绑定客户微信，绑定路径：华夏银行信用卡微信公众号-活动·权益-权益平台-我的券，点击已生效的微信立减金，按照页面指引完成绑定，绑定后可至微信-我-卡包查看。使用有效期自绑定之日起30天（含），具体以券码展示为准。请客户在规定时间内绑定微信并使用立减金，过期将自动作废，无法退换、延期或补发。<br />
        4、每位持卡人仅限参与一次，获赠1件礼品，如同时满足多个卡种活动条件的持卡人，参与活动卡种以客户首张批核的卡片为准（具体以华夏银行信用卡系统判定为准），不可重复参加。<br />
        5、本活动达标消费指线上渠道的消费交易，转账、提现、还款以及存在撤销、冲正的交易金额不计入达标统计范围。活动交易达标金额以华夏银行信用卡账单入账金额为准。活动交易统计时间以华夏银行信用卡系统记账日期为准。交易渠道认定以华夏银行信用卡系统数据为准。美元按1:7汇率转换人民币进行计算。<br />
        6、礼品视库存情况调整，数量有限，先到先得。礼品一经领取无法更改。礼品不开具发票。礼品提供给客户后，客户应妥善保管，华夏银行信用卡中心不对礼品的遗失或被盗负责。华夏银行信用卡中心不是礼品的生产商或供应商，礼品的任何质量问题、售后服务均由礼品供应商负责，华夏银行信用卡中心将为持卡人提供必要协助。<br />
        7、本活动适用于华夏银行信用卡中心发行的有效信用卡。持卡人如有下述任一情形：所持信用卡被停用或管制、自行注销账户信用卡、对华夏银行信用卡中心其他债务不偿还、违反《华夏银行信用卡章程》及《华夏银行信用卡（个人卡）领用合约》或本活动办法的，即失去参加本次活动的资格。<br />
      </p>
    </div>
    <div class="rulebox1">
      <img src="@/assets/hxStatic/rule_title.jpg" />
      <div class="title">月月礼</div>
      <h4>活动时间</h4>
      <p>2023年7月1日起至2023年12月31日（客户核卡日期）</p>
      <h4>活动对象</h4>
      <p>申请华夏银行指定信用卡产品的新户持卡人。主要包含卡产品如下：</p>
      <img src="@/assets/hxStatic/rule3.png" />
      <h4>活动内容</h4>
      <p>
        畅享月月礼活动新客户自成功核卡次月起6个月内，
        <span class="anthorColor">每月消费交易满2笔且每笔满199元</span>，
        即可每月领取价值30元代金券（任选其一）。每人每月限领1次。
      </p>
      <div class="lists">
        <div>
          <img src="@/assets/hxStatic/list_wx.jpg" />
          <h4>微信30元立减金</h4>
        </div>
        <div>
          <img src="@/assets/hxStatic/list_bsk.jpg" />
          <h4>必胜客30元代金券</h4>
        </div>
        <div>
          <img src="@/assets/hxStatic/list_tm.jpg" />
          <h4>天猫30元购物券</h4>
        </div>
        <div>
          <img src="@/assets/hxStatic/list_jd_30.jpg" />
          <h4>京东E卡30元面值</h4>
        </div>
      </div>
      <p>
        怡享月月礼活动新客户自成功核卡次月起6个月内，
        <span class="anthorColor">每月消费交易满2笔且每笔满99元</span>，
        即可每月领取价值20元代金券（任选其一）。每人每月限领1次。
      </p>
      <div class="lists">
        <div>
          <img src="@/assets/hxStatic/list_wx.jpg" />
          <h4>微信20元立减金</h4>
        </div>
        <div>
          <img src="@/assets/hxStatic/list_kdj.jpg" />
          <h4>肯德基20元代金券</h4>
        </div>
        <div>
          <img src="@/assets/hxStatic/list_tm.jpg" />
          <h4>天猫20元购物券</h4>
        </div>
        <div>
          <img src="@/assets/hxStatic/list_jd_20.jpg" />
          <h4>京东E卡20元面值</h4>
        </div>
      </div>
      <h4>礼品领取</h4>
      <p>
        满足达标条件的客户，可于达标次日收到达标短信后30天（含）内，前往“华夏银行信用卡微信公众号-活动·权益-权益平台-精彩活动”或“华彩生活APP-权益平台-精彩活动”进行领取。
      </p>
      <h4>活动细则</h4>
      <p style="text-indent:inherit">
        1、本活动仅限新客户参与：新客户是指申请以上指定信用卡产品前，名下未曾持有华夏银行信用卡的主卡持卡人。<br/>
        2、领取有效期为每月达标日的第二天起至第30天（含），请在活动规定时间内领取，如逾期未领取，则视为放弃该礼品。领取路径：华夏银行信用卡微信公众号-活动·权益-权益平台-精彩活动，或华彩生活APP-权益平台-精彩活动。<br/>
        3、每位持卡人核卡次月起6个月内每月仅限参与一次，获赠1件礼品。如同时满足多个卡种活动条件的持卡人，参与活动卡种以客户首张批核的卡片为准（具体以华夏银行信用卡系统判定为准），不可重复参加。<br/>
        4、本活动达标交易指消费交易（不限定交易渠道），转账、提现、还款以及存在撤销、冲正的交易金额不计入达标统计范围。活动交易达标金额以华夏银行信用卡账单入账金额为准。活动交易统计时间以华夏银行信用卡系统记账日期为准。美元按1:7汇率转换人民币进行计算。<br/>
        5、礼品视库存情况调整，数量有限，先到先得。礼品一经领取无法更改。礼品不开具发票。礼品提供给客户后，客户应妥善保管，华夏银行信用卡中心不对礼品的遗失或被盗负责。华夏银行信用卡中心不是礼品的生产商或供应商，礼品的任何质量问题、售后服务均由礼品供应商负责，华夏银行信用卡中心将为持卡人提供必要协助。<br/>
        6、本活动适用于华夏银行信用卡中心发行的有效信用卡。持卡人如有下述任一情形：所持信用卡被停用或管制、自行注销账户信用卡、对华夏银行信用卡中心其他债务不偿还、违反《华夏银行信用卡章程》及《华夏银行信用卡（个人卡）领用合约》或本活动办法的，即失去参加本次活动的资格。<br/>
        7.如有其他疑问，可咨询华夏银行信用卡客服热线4006695577。<br/>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {}
}
</script>

<style lang="less" scoped>
.rulebox1 {
  background: #fff;
  padding: 0 16px 20px;
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
  font-size: 12px;
  color: #333333;
  margin: 0 0 22px 0;
  position: relative;
  .title {
    position: absolute;
    left: 50%;
    top: 24px;
    transform: translateX(-50%);
    font-size: 17px;
    color: #ffffff;
  }
  & > h4 {
    font-size: 14px;
    font-weight: bold;
    padding: 0 0 8px 12px;
    position: relative;
    line-height: 20px;
    &::before {
      position: absolute;
      left: 0;
      top: 4px;
      width: 3px;
      height: 12px;
      content: '';
      background: linear-gradient(90deg, #ff893e 4%, #ff574d 100%);
      border-radius: 11.5px;
    }
  }
  & > p {
    padding-bottom: 8px;
    line-height: 1.5;
    text-indent: 2em;
  }
  & > img {
    width: 100vw;
    display: block;
    margin: 0 -16px;
  }
  .anthorColor {
    font-size: 12px;
    color: #a56426;
  }
  .lists {
    display: flex;
    flex-flow: wrap;
    font-size: 13px;
    color: #333333;
    justify-content: space-around;
    padding: 12px 0 24px;
    text-align: center;
    & > div {
      margin-bottom: 12px;
      & > img {
        width: 117px;
        height: 72px;
        margin-bottom: 4px;
      }
    }
  }
}
</style>
